import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Button, Col, Container, Nav, NavItem, NavLink, Row, TabContent, Input, TabPane, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Label } from 'reactstrap';
import classnames from "classnames";
import { GolbalDataContext } from '../../components/store/global-data-provider';
import TableDashboard from '../../components/common/table-dashboard';
import axios from "axios";
import ConfigData from '../../config.json';
import { groupStatusToPage } from '../../components/model/static-data';
import Select from "react-select";

const RequestLists = () => {
    const history = useHistory();
    const { changeTitlePage, changeColorName } = useContext(GolbalDataContext);
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const [originalDataAll, setOriginalDataAll] = useState([]);
    const [dataAll, setDataAll] = useState([]);
    const [dataWaitingForApprove, setDataWaitingForApprove] = useState([]);
    const [dataInProgress, setDataInProgresss] = useState([]);
    const [dataReject, setDataReject] = useState([]);
    const [dataComplete, setDataComplete] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const userEmail = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
    const [txtSearch, setTxtSearch] = useState("");
    const [selectSort, setSelectSort] = useState(null);
    const [ddlShowFormType, setDdlShowFormType] = useState([]);
    const [selectShowFormType, setSelectShowFormType] = useState(null);
    const [ddlShowRequestBy, setDdlShowRequestBy] = useState([]);
    const [selectShowRequestBy, setSelectShowRequestBy] = useState(null);
    const [ddlShowBusinessunit, setDdlShowBusinessunit] = useState([]);
    const [selectShowBusinessunit, setSelectShowBusinessunit] = useState(null);
    const [ddlShowLegalTeam, setDdlShowLegalTeam] = useState([]);
    const [selectShowLegalTeam, setSelectShowLegalTeam] = useState(null);
    const [total, setTotal] = useState(null); // เก็บค่าจำนวนผลลัพธ์
    const [isSearched, setIsSearched] = useState(false); // ใช้ตรวจสอบว่ามีการค้นหาหรือไม่

    useEffect(() => {
        changeTitlePage("All Request");
        LoadDataRequest();
        LoadDataFormType();
        LoadDataRequestBy();
        LoadDataBusinessunit();
        LoadDataLegalTeam();
    }, []);

    const handleSearch = (searchText) => {
        const formType = selectShowFormType?.value || "";
        const requestBy = selectShowRequestBy?.label || "";
        const businessUnit = selectShowBusinessunit?.value || "";
        const legalTeam = selectShowLegalTeam?.label || "";
        onSearch(searchText, formType, requestBy, businessUnit, legalTeam);
    };

    const prepareSearchParams = (updatedValue, field) => {
        const params = {
            txtSearch,
            selectShowFormType: selectShowFormType?.value || "",
            selectShowRequestBy: selectShowRequestBy?.label || "",
            selectShowBusinessunit: selectShowBusinessunit?.value || "",
            selectShowLegalTeam: selectShowLegalTeam?.label || "",
        };
    
        // อัปเดตค่าที่เปลี่ยนแปลงใน field
        if (field === "selectShowFormType") params.selectShowFormType = updatedValue || "";
        if (field === "selectShowRequestBy") params.selectShowRequestBy = updatedValue || "";
        if (field === "selectShowBusinessunit") params.selectShowBusinessunit = updatedValue || "";
        if (field === "selectShowLegalTeam") params.selectShowLegalTeam = updatedValue || "";
    
        return params;
    };

    const onSearch = (strSearch, strShowFormTemp, strShowRequestBy, strShowBusinessUnit, strLegalTeam) => {
        if(strSearch === "" && strShowFormTemp === "" && strShowRequestBy === "" && strShowBusinessUnit === "" && strLegalTeam === "" ){
            setIsSearched(false);
        } else {
            setIsSearched(true); // ระบุว่ามีการค้นหา
        }

        let arrSearchData = [...originalDataAll];

        const statusLabels = {
            1: "Waiting for approve",
            2: "Waiting for approve",
            8: "Waiting for approve",
            12: "Waiting for approve",
            17: "Waiting for approve",
            18: "Waiting for approve",
            20: "Waiting for approve",
            3: "Waiting for acceptance",
            5: "Waiting for acceptance",
            4: "Return",
            7: "Reviewing",
            9: "Reviewing",
            14: "Reviewing",
            10: "Reviewing",
            15: "Reviewing",
            16: "Reviewing",
            19: "Reviewing",
            21: "Reviewing",
            6: "Reject",
            11: "Reject",
            13: "Reject",
            0: "Draft",
            22: "Complete"
        };

        if(strShowFormTemp !== null && strShowFormTemp !== ""){
            arrSearchData = arrSearchData.filter((item) => {
                return item.id_form_temp?.toString() === strShowFormTemp;
            });
        }

        if(strShowRequestBy !== null && strShowRequestBy !== ""){
            arrSearchData = arrSearchData.filter((item) => {
                return item.request_by === strShowRequestBy;
            });
        }

        if(strShowBusinessUnit !== null && strShowBusinessUnit !== ""){
            arrSearchData = arrSearchData.filter((item) => {
                return item.id_user_businessunit?.toString() === strShowBusinessUnit;
            });
        }

        if (strLegalTeam !== null && strLegalTeam !== "") {
            arrSearchData = arrSearchData.filter((item) => {
                const emails = item.accept_request_by.split(",");
                return emails.includes(strLegalTeam);
            });
        }

        if(strSearch !== null && strSearch !== ""){
            arrSearchData = arrSearchData.filter((item) => {
                let dataMap = item.request_no + " " + item.request_date + " " + item.form_temp_full_name + " " + item.request_by + " " + item.user_business_unit_name_en + " " + item.confidential_level_name_en + " " + item.accept_request_by + " " + item.id_workflow_status;
                // เพิ่มการค้นหาจาก label ของ status
                const statusLabel = statusLabels[item.id_workflow_status];
                dataMap = dataMap + " " + statusLabel; // เพิ่ม status label ลงไปใน dataMap
                dataMap = dataMap.toLocaleLowerCase();
                return dataMap.includes(strSearch.toLocaleLowerCase());
            });
        }
        const arrDataAll = arrSearchData;
        const arrDataWaitingForApprove = arrSearchData.filter((e) => e.id_workflow_status === 1 || e.id_workflow_status === 2 || e.id_workflow_status === 8 
                                                                    || e.id_workflow_status === 12 || e.id_workflow_status === 17 || e.id_workflow_status === 18 
                                                                    || e.id_workflow_status === 20);
        const arrDataInProgress = arrSearchData.filter((e) => e.id_workflow_status === 3 || e.id_workflow_status === 4 || e.id_workflow_status === 5
                                                                    || e.id_workflow_status === 7 || e.id_workflow_status === 9 || e.id_workflow_status === 14
                                                                    || e.id_workflow_status === 10 || e.id_workflow_status === 15 || e.id_workflow_status === 16
                                                                    || e.id_workflow_status === 19 || e.id_workflow_status === 21);
        const arrDataReject = arrSearchData.filter((e) => e.id_workflow_status === 6 || e.id_workflow_status === 11 || e.id_workflow_status === 13);
        const arrDataComplete = arrSearchData.filter((e) => e.id_workflow_status === 22);
        const arrDataDraft = arrSearchData.filter((e) => e.id_workflow_status === 0);
        setDataAll(arrDataAll);
        setDataWaitingForApprove(arrDataWaitingForApprove);
        setDataInProgresss(arrDataInProgress);
        setDataReject(arrDataReject);
        setDataComplete(arrDataComplete);
        setDataDraft(arrDataDraft);
        setTotal(arrSearchData.length);
    };

    const columnAll = [
        {
            key: "request_no",
            name: <span className='font-weight-bold'>Request No.</span>,
            cell: (row, index) => row.request_no,
            width: "12%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "request_date",
            name: <span className='font-weight-bold'>Date Created</span>,
            cell: (row, index) => row.request_date,
            width: "14%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "form_temp_full_name",
            name: <span className='font-weight-bold'>Type</span>,
            cell: (row, index) => row.form_temp_full_name,
            width: "10%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "request_by",
            name: <span className='font-weight-bold'>Request By</span>,
            cell: (row, index) => {
                return (
                    <div className="truncate">
                        {row.request_by}
                    </div>
                );
            },
            width: "14%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "user_business_unit_name_en",
            name: <span className='font-weight-bold'>Business Unit</span>,
            cell: (row, index) => row.user_business_unit_name_en,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "confidential_level_name_en",
            name: <span className='font-weight-bold'>Level</span>,
            cell: (row, index) => {
                return(
                    <label className={"rtc-table-level " + ( row.id_confidential_level !== "0" ? ((row.id_confidential_level == 2) ? "rtc-table-level-confidential" : "rtc-table-level-normal") : "")}>{row.confidential_level_name_en}</label>
                );
            },
            width: "10%",
            classHeader: "text-center",
            classBody: "text-center",
            sortable: true
        },
        {
            key: "accept_request_by",
            name: <span className='font-weight-bold'>Legal Team</span>,
            cell: (row, index) => {
                const emails = row.accept_request_by.replaceAll(',', '\n,');
                return(
                    <label> {emails}</label>
                );
            },
            width: "16%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "id_workflow_status",
            name: <span className='font-weight-bold'>Status</span>,
            cell: (row, index) => {
                if(row.id_workflow_status === 1 || row.id_workflow_status === 2 || row.id_workflow_status === 8 
                    || row.id_workflow_status === 12 || row.id_workflow_status === 17 || row.id_workflow_status === 18 
                    || row.id_workflow_status === 20){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-clock-time-four-outline rtc-ts-wating-for-approve"></i>
                            <label>Waiting for approve</label>
                        </div>
                    );
                }else if(row.id_workflow_status === 3 || row.id_workflow_status === 5){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-timer-sand-empty rtc-ts-in-progress"></i>
                            <label>Waiting for acceptance</label>
                        </div>
                    );
                }else if(row.id_workflow_status === 4 ){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-timer-sand-empty rtc-ts-in-progress"></i>
                            <label>Return</label>
                        </div>
                    );
                }else if( row.id_workflow_status === 7 || row.id_workflow_status === 9 || row.id_workflow_status === 14
                    || row.id_workflow_status === 10 || row.id_workflow_status === 15 || row.id_workflow_status === 16
                    || row.id_workflow_status === 19 || row.id_workflow_status === 21){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-timer-sand-empty rtc-ts-in-progress"></i>
                            <label>Reviewing</label>
                        </div>
                    );
                }else if(row.id_workflow_status === 6 || row.id_workflow_status === 11 || row.id_workflow_status === 13){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-rotate-left rtc-ts-reject"></i>
                            <label>Reject</label>
                        </div>
                    );
                }else if(row.id_workflow_status === 0){
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-rotate-left rtc-ts-reject"></i>
                            <label>Draft</label>
                        </div>
                    );
                }else{
                    return (
                        <div className="rtc-table-status">
                            <i className="mdi mdi-check dtdl-wfa-icon rtc-ts-complete"></i>
                            <label>Complete</label>
                        </div>
                    );
                }
            },
            width: "10%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        // {
        //     key: "action",
        //     name: <span className='font-weight-bold fs-13'></span>,
        //     cell: (row, index) => {
        //         return(
        //             <UncontrolledDropdown key={index}>
        //                 <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
        //                 <DropdownMenu className="dropdown-menu-end">
        //                     <li>
        //                         <DropdownItem onClick={() => onClickUpdate(row)}>
        //                             <i className="ri-pencil-fill"></i> Edit
        //                         </DropdownItem>
        //                     </li>
        //                     {row.request_no === "draft" ? (
        //                         <li>
        //                         <DropdownItem onClick={() => onClickDelete(row.id)}>
        //                             <i className="ri-delete-bin-line"></i> Delete
        //                         </DropdownItem>
        //                         </li>
        //                     ) : (
        //                         <li>
        //                         {/* Add your alternative action here */}
        //                         <DropdownItem onClick={() => onClickCancel(row)}>
        //                             <i className="ri-delete-bin-line"></i> Delete
        //                         </DropdownItem>
        //                         </li>
        //                     )}
        //                 </DropdownMenu>
        //             </UncontrolledDropdown>
        //         )
        //     },
        //     width: "10%",
        //     classHeader: "text-start",
        //     classBody: "text-end",
        //     sortable: false
        // }
    ];

    const columnForStatus = [
        {
            key: "request_no",
            name: <span className='font-weight-bold'>Request No.</span>,
            cell: (row, index) => row.request_no,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        {
            key: "request_date",
            name: <span className='font-weight-bold'>Date Created</span>,
            cell: (row, index) => row.request_date,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "form_temp_full_name",
            name: <span className='font-weight-bold'>Type</span>,
            cell: (row, index) => row.form_temp_full_name,
            width: "10%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "request_by",
            name: <span className='font-weight-bold'>Request By</span>,
            cell: (row, index) => {
                return (
                    <div className="truncate">
                        {row.request_by}
                    </div>
                );
            },
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "user_business_unit_name_en",
            name: <span className='font-weight-bold'>Business Unit</span>,
            cell: (row, index) => row.user_business_unit_name_en,
            width: "15%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "confidential_level_name_en",
            name: <span className='font-weight-bold'>Level</span>,
            cell: (row, index) => {
                return(
                    <label className={"rtc-table-level " + ( row.id_confidential_level !== "0" ? ((row.id_confidential_level == 2) ? "rtc-table-level-confidential" : "rtc-table-level-normal") : "")}>{row.confidential_level_name_en}</label>
                );
            },
            width: "10%",
            classHeader: "text-center",
            classBody: "text-center",
            sortable: true
        },
        {
            key: "accept_request_by",
            name: <span className='font-weight-bold'>Legal Team</span>,
            cell: (row, index) => {
                // if (row.accept_request_by) {
                //     const emails = row.accept_request_by.split(',').filter(email => email.trim() !== '');
                //     return (
                //         <span>
                //             {emails.map((email, i) => (
                //                 <React.Fragment key={i}>
                //                     {email}
                //                     {i < emails.length - 1 && <br />} {/* เพิ่ม <br /> ระหว่างอีเมล */}
                //                 </React.Fragment>
                //             ))}
                //         </span>
                //     );
                // }
                // return null; // หรือใช้ '-' ถ้าต้องการแสดงข้อความเมื่อไม่มีข้อมูล
                const emails = row.accept_request_by.replaceAll(',', '\n,');
                return(
                    <label>{emails}</label>
                );
            },
            width: "20%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        // {
        //     key: "action",
        //     name: <span className='font-weight-bold fs-13'></span>,
        //     cell: (row, index) => {
        //         return(
        //             <UncontrolledDropdown key={index}>
        //                 <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
        //                 <DropdownMenu className="dropdown-menu-end">
        //                     <li>
        //                         <DropdownItem onClick={() => onClickUpdate(row)}>
        //                             <i className="ri-pencil-fill"></i> Edit
        //                         </DropdownItem>
        //                     </li>
        //                 {row.request_no === "draft" ? (
        //                     <li>
        //                     <DropdownItem onClick={() => onClickDelete(row.id)}>
        //                         <i className="ri-delete-bin-line"></i> Delete
        //                     </DropdownItem>
        //                     </li>
        //                 ) : (
        //                     <li>
        //                     {/* Add your alternative action here */}
        //                     <DropdownItem onClick={() => onClickCancel(row)}>
        //                         <i className="ri-delete-bin-line"></i> Delete
        //                     </DropdownItem>
        //                     </li>
        //                 )}
        //                 </DropdownMenu>
        //             </UncontrolledDropdown>
        //         )
        //     },
        //     width: "10%",
        //     classHeader: "text-start",
        //     classBody: "text-end",
        //     sortable: false
        // }
    ];

    const toggleCustomActiveTab = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const OnClickDetail = (data) => {
        let reqId = btoa(data.id);
        let urlPage;
        let url;
        urlPage = groupStatusToPage.find((e) => {
            return e.workflow_status.includes(data.id_workflow_status);
        });

        const checkUserCreateRequestBy = (
            data.create_request_by !== userEmail 
            || data.create_request_by === data.request_by 
            || data.id_workflow_status > 3
        );

        if(typeof(urlPage) !== "undefined"){
                if( checkUserCreateRequestBy ) { // check user if create_request_by ?
                    url = urlPage.url_page.replace(":id", reqId);
                    history.push(url);
                } else {
                    url = "/summary-request/"+reqId;
                    history.push(url);
                }
        } else {
            // case draft
            if(data.id_workflow_status === 0){
                url = "/request/"+reqId;
                history.push(url);
            }
        }
    };

    const LoadDataRequest = () => {
        const email = (!localStorage.getItem("emd")) ? "--" : atob(localStorage.getItem("emd"));
        let url = ConfigData.API_URL + "request/email/all/" + email;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrDataAll = respData.data;
                //console.log(arrDataAll);
                const arrDataWaitingForApprove = respData.data.filter((e) => e.id_workflow_status === 1 || e.id_workflow_status === 2 || e.id_workflow_status === 8 
                                                                            || e.id_workflow_status === 12 || e.id_workflow_status === 17 || e.id_workflow_status === 18 
                                                                            || e.id_workflow_status === 20);
                const arrDataInProgress = respData.data.filter((e) => e.id_workflow_status === 3 || e.id_workflow_status === 4 || e.id_workflow_status === 5
                                                                            || e.id_workflow_status === 7 || e.id_workflow_status === 9 || e.id_workflow_status === 14
                                                                            || e.id_workflow_status === 10 || e.id_workflow_status === 15 || e.id_workflow_status === 16
                                                                            || e.id_workflow_status === 19 || e.id_workflow_status === 21);
                const arrDataReject = respData.data.filter((e) => e.id_workflow_status === 6 || e.id_workflow_status === 11 || e.id_workflow_status === 13);
                const arrDataComplete = respData.data.filter((e) => e.id_workflow_status === 22);
                const arrDataDraft = respData.data.filter((e) => e.id_workflow_status === 0);
                setOriginalDataAll(arrDataAll); // เก็บข้อมูลต้นฉบับ
                setDataAll(arrDataAll);
                setDataWaitingForApprove(arrDataWaitingForApprove);
                setDataInProgresss(arrDataInProgress);
                setDataReject(arrDataReject);
                setDataComplete(arrDataComplete);
                setDataDraft(arrDataDraft);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataFormType = () => {
        let url = ConfigData.API_URL + "form-temp/?status=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.full_name,
                        value: e.id.toString(),
                    };
                });
                setDdlShowFormType(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataRequestBy = () => {
        let url = ConfigData.API_URL + "user/?status=1&request_by=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.email,
                        value: e.id.toString(),
                    };
                });
                setDdlShowRequestBy(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataBusinessunit = () => {
        let url = ConfigData.API_URL + "business-unit/ddl";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en,
                        value: e.id.toString(),
                    };
                });
                setDdlShowBusinessunit(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    const LoadDataLegalTeam = () => {
        let url = ConfigData.API_URL + "user/?status=1&legal_team=1";
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.email,
                        value: e.id.toString(),
                    };
                });
                setDdlShowLegalTeam(arrData);
            }
        })
        .catch(error => {
            console.log(error);
            // handlerRespError(error, history);
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="request-tracking-contract">
                        <Col xl={12}>
                            <Row>
                                <Col xl={6}>
                                    <p className="rtc-title">Tracking Contract</p>
                                </Col>
                                <Col xl={6}>
                                    <Link to="/create-requests">
                                        <Button 
                                            className="float-end" 
                                            color="primary" 
                                            style={{borderRadius:'8px', height:'50px'}} 
                                            type="button" 
                                        >
                                            <i className="mdi mdi-plus"></i> Create Request
                                        </Button>
                                    </Link>
                                </Col>
                                <Col sm={12} md={6} lg={6}>
                                    <div className="form-icon right mb-2">
                                        <Input 
                                            className="form-control input-search" 
                                            type="text" 
                                            id="txtSerachTable" 
                                            placeholder="Search" 
                                            value={txtSearch || ""} 
                                            onChange={(e) => {
                                                setTxtSearch(e.target.value); 
                                                handleSearch(e.target.value); 
                                            }} 
                                        />
                                        <i className="ri-search-2-line"></i>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <Row>
                                        <div className="filter-ddl1">
                                        <Select
                                            id="ddlShowFormType"
                                            name="ddlShowFormType"
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: selectShowFormType || state.isFocused ? '#0778FF' : '#F4F6F9',
                                                    borderRadius: '24px',
                                                    color: selectShowFormType || state.isFocused ? '#FFFFFF' : '#000000',
                                                    boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none',
                                                    transition: 'background-color 0.3s ease',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#FFFFFF',
                                                }),
                                                placeholder: (provided, state) => ({
                                                    ...provided,
                                                    color: selectShowFormType || state.isFocused ? '#FFFFFF' : '#8E8E8E',
                                                }),
                                                dropdownIndicator: (provided, state) => ({
                                                    ...provided,
                                                    color: selectShowFormType || state.isFocused ? '#FFFFFF' : '#000000',
                                                }),
                                                clearIndicator: (provided) => ({
                                                    ...provided,
                                                    color: '#FFFFFF',
                                                    '&:hover': {
                                                        color: '#FFFFFF',
                                                    },
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#FFFFFF',
                                                }),
                                            }}
                                            value={selectShowFormType}
                                            onChange={(selected) => {
                                                setSelectShowFormType(selected);
                                                const params = prepareSearchParams(selected?.value, "selectShowFormType");
                                                onSearch(params.txtSearch, params.selectShowFormType, params.selectShowRequestBy, params.selectShowBusinessunit, params.selectShowLegalTeam);
                                            }}
                                            options={ddlShowFormType}
                                            isClearable={true}
                                            isSearchable={true}
                                            placeholder="Type"
                                        />
                                        </div>
                                        <div className="filter-ddl2">
                                            <Select id="ddlShowRequestBy"
                                                name="ddlShowRequestBy"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: selectShowRequestBy || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                        borderRadius: '24px',
                                                        color: selectShowRequestBy || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                        boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                        transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowRequestBy || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                                    }),
                                                    dropdownIndicator: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowRequestBy || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                                    }),
                                                    clearIndicator: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // สีของ "x"
                                                        '&:hover': {
                                                            color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                        },
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                                    }),
                                                }}
                                                value={selectShowRequestBy}
                                                onChange={(selected) => {
                                                    setSelectShowRequestBy(selected);
                                                    const params = prepareSearchParams(selected?.label, "selectShowRequestBy");
                                                    onSearch(params.txtSearch, params.selectShowFormType, params.selectShowRequestBy, params.selectShowBusinessunit, params.selectShowLegalTeam);
                                                }}
                                                options={ddlShowRequestBy}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Request By"
                                            /> 
                                        </div>
                                        <div className="filter-ddl2">
                                            <Select id="ddlShowBusinessunit"
                                                name="ddlShowBusinessunit"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: selectShowBusinessunit || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                        borderRadius: '24px',
                                                        color: selectShowBusinessunit || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                        boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                        transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowBusinessunit || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                                    }),
                                                    dropdownIndicator: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowBusinessunit || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                                    }),
                                                    clearIndicator: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // สีของ "x"
                                                        '&:hover': {
                                                            color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                        },
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                                    }),
                                                }}
                                                value={selectShowBusinessunit}
                                                onChange={(selected) => {
                                                    setSelectShowBusinessunit(selected);
                                                    const params = prepareSearchParams(selected?.value, "selectShowBusinessunit");
                                                    onSearch(params.txtSearch, params.selectShowFormType, params.selectShowRequestBy, params.selectShowBusinessunit, params.selectShowLegalTeam);
                                                }}
                                                options={ddlShowBusinessunit}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Business Unit"
                                            /> 
                                        </div>
                                        <div className="filter-ddl2">
                                            <Select id="ddlShowLegalTeam"
                                                name="ddlShowLegalTeam"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: selectShowLegalTeam || state.isFocused ? '#0778FF' : '#F4F6F9', // คงสีเมื่อมีค่าหรือโฟกัส
                                                        borderRadius: '24px',
                                                        color: selectShowLegalTeam || state.isFocused ? '#FFFFFF' : '#000000', // ตัวอักษรสีขาวเมื่อมีค่าหรือโฟกัส
                                                        boxShadow: state.isFocused ? '0 0 0 2px rgba(7, 120, 255, 0.5)' : 'none', // เพิ่มเอฟเฟกต์เมื่อโฟกัส
                                                        transition: 'background-color 0.3s ease', // เพิ่ม transition เพื่อความสวยงาม
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรสีขาวในสถานะที่มีค่าที่เลือก
                                                    }),
                                                    placeholder: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowLegalTeam || state.isFocused ? '#FFFFFF' : '#8E8E8E', // สีของลูกศร
                                                    }),
                                                    dropdownIndicator: (provided, state) => ({
                                                        ...provided,
                                                        color: selectShowLegalTeam || state.isFocused ? '#FFFFFF' : '#000000', // สีของลูกศร
                                                    }),
                                                    clearIndicator: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // สีของ "x"
                                                        '&:hover': {
                                                            color: '#FFFFFF', // สีของ "x" เมื่อ hover
                                                        },
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#FFFFFF', // ตัวอักษรที่พิมพ์ในช่องค้นหา
                                                    }),
                                                }}
                                                value={selectShowLegalTeam}
                                                onChange={(selected) => {
                                                    setSelectShowLegalTeam(selected);
                                                    const params = prepareSearchParams(selected?.label, "selectShowLegalTeam");
                                                    onSearch(params.txtSearch, params.selectShowFormType, params.selectShowRequestBy, params.selectShowBusinessunit, params.selectShowLegalTeam);
                                                }}
                                                options={ddlShowLegalTeam}
                                                isClearable={true}
                                                isSearchable={true}
                                                placeholder="Legal Team"
                                            /> 
                                        </div>
                                    </Row>
                                    {isSearched && total !== null && (
                                        <Label className="total-search">{total !== null && `'${total} Result${total > 1 ? 's' : ''}'`}</Label>
                                    )}
                                </Col>
                            </Row>
                            <div className="rtc-content">
                                {/* <Nav tabs className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"> */}
                                <Nav tabs className="nav nav-tabs nav-tabs-dashboard mb-3">
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("1");
                                            }}
                                        >
                                            All
                                            <span className="nav-noti">
                                                <label>{dataAll.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("2");
                                            }}
                                        >
                                            Waiting for approve
                                            <span className="nav-noti">
                                                <label>{dataWaitingForApprove.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("3");
                                            }}
                                        >
                                            In Progress
                                            <span className="nav-noti">
                                                <label>{dataInProgress.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "4",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("4");
                                            }}
                                        >
                                            Reject
                                            <span className="nav-noti">
                                                <label>{dataReject.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "5",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("5");
                                            }}
                                        >
                                            Complete
                                            <span className="nav-noti">
                                                <label>{dataComplete.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink 
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "6",
                                            })}
                                            onClick={() => {
                                                toggleCustomActiveTab("6");
                                            }}
                                        >
                                            Draft
                                            <span className="nav-noti">
                                                <label>{dataDraft.length}</label>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={customActiveTab}>
                                    <TabPane tabId="1" id="tab1">
                                        {/* <TableDashboard data={dataAll} column={columnAll} OnClickDetail={OnClickDetail} /> */}
                                        <TableDashboard data={dataAll} column={columnAll} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                    <TabPane tabId="2" id="tab2">
                                        <TableDashboard data={dataWaitingForApprove} column={columnForStatus} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                    <TabPane tabId="3" id="tab3">
                                        <TableDashboard data={dataInProgress} column={columnForStatus} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                    <TabPane tabId="4" id="tab4">
                                        <TableDashboard data={dataReject} column={columnForStatus} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                    <TabPane tabId="5" id="tab5">
                                        <TableDashboard data={dataComplete} column={columnForStatus} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                    <TabPane tabId="6" id="tab6">
                                        <TableDashboard data={dataDraft} column={columnForStatus} OnClickDetail={OnClickDetail} />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default RequestLists;